import { call, put, takeEvery } from "redux-saga/effects"

import {
  CREATE_AD_GROUP_AD,
  DELETE_AD_GROUP_AD,
  GET_AD_GROUP_AD,
  UPDATE_AD_GROUP_AD
} from "./actionTypes"

import {
  createAdGroupAdError,
  createAdGroupAdSuccess,
  deleteAdGroupAdError,
  deleteAdGroupAdSuccess,
  getAdGroupAdError, getAdGroupAdSuccess, updateAdGroupAdError, updateAdGroupAdSuccess
} from "./actions"

import { genericGetRequest, genericPutRequest, genericPostRequest, genericDeleteRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetAdGroupAd() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_ads`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getAdGroupAdSuccess(response))
  } catch (error) {
    yield put(getAdGroupAdError(error))
  }
}

function* onCreateAdGroupAd(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_ads`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(createAdGroupAdSuccess(response))
  } catch (error) {
    yield put(createAdGroupAdError(error))
  }
}

function* onUpdateAdGroupAd(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_ads/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdGroupAdSuccess(response))
  } catch (error) {
    yield put(updateAdGroupAdError(error))
  }
}

function* onDeleteAdGroupAd(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_ads/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteAdGroupAdSuccess(response))
  } catch (error) {
    yield put(deleteAdGroupAdError(error))
  }
}


function* adGroupAdSaga() {
  yield takeEvery(GET_AD_GROUP_AD, onGetAdGroupAd)
  yield takeEvery(CREATE_AD_GROUP_AD, onCreateAdGroupAd)
  yield takeEvery(UPDATE_AD_GROUP_AD, onUpdateAdGroupAd)
  yield takeEvery(DELETE_AD_GROUP_AD, onDeleteAdGroupAd)
}

export default adGroupAdSaga
